export const hospitalProceduresColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'code',
  'description',
  'fk_hospital__data_doc_new_id',
  'is_scrubbed',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'ordered_date',
  'post_date_time',
  'procedure_surgical_flag',
  'sequence',
  'service_date',
  'snapshot_id',
  'transaction_id',
  'version',
];
